import React, {useContext, useState} from 'react'
import { Col, Row } from 'react-bootstrap';
import Accordion from '../../../components/Accordion';
import AccordionBodyItem from '../../../components/Accordion/AccordionBodyItem';
import AvatarGroup, {
  AvatarGroupSize,
  AvatarGroupStyle,
} from '../../../components/Avatar/AvatarGroup';
import { AuthStore } from '../../../providers/auth';
import Button from '../../../components/Button';
import IconButton from '../../../components/IconButton';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import {
    addOrRemoveDaysToGivenDate,
    formatDate,
    DateFormats,
    formatPrice,
    openExternalLink,
  } from '../../../utils/utils';
import { useNavigate } from 'react-router-dom';
import {PaymentInformationStore} from '../../../providers/payment-information';
import Popover from '../../../components/Popover';
import { mapProfileIds } from '../../../services/profiles';

const ElectionByDate = () => {
    const navigate = useNavigate();
    const today = new Date();
    const handleRedirect = (link: string) => {
      return navigate(link);
    };
    const handleAlertClick = (info: any) => {
        if (!info.route) {
          return;
        }
        if (info.file || info.target === '_href') {
          window.open(`${process.env.PUBLIC_URL}/${info.route}`);
          return;
        }
        if (info.modal) {
          document.body.click();
          return;
        }
    
        navigate(info.route);
      };
    const [switched, setSwitched] = useState(false);
    const [filteringData, setFilteringData] = useState<any>({
      filterOption: undefined,
      filterInfo: undefined,
    });
    const [filterData, setFilterData] = useState<any>({
      filterOption: undefined,
      filterInfo: undefined,
    });
    const [expanded, setExpanded] = useState([
      { activeKey: '1', id: 0 },
      { activeKey: '1', id: 1 },
      { activeKey: '1', id: 2 },
      { activeKey: '1', id: 3 },
    ]);
    const [shouldShowCurrentValue] = useState<boolean>(false);
    const [] = useContext(AuthStore) || [];
    const {
      fingertipLinks,
      activeHealthBenefits,
      activeLifeAndDisabilityInsurances,
      activeLifestyleBenefits,
      activeSpendingAccounts,
      currentLifeEvent,
      currentPersona,
    } = useContext(PaymentInformationStore) || {};

    const separateStringAndMakeFirstLetterUppercase = (str: string) => {
        return str
          .split('-')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      };

    const getCardIcon = (type: String) => {
        switch (type) {
            case 'heart-pulse':
                return light('heart-pulse');
            case 'tooth':
                return light('tooth');
            case 'glasses':
                return light('glasses');
            case 'face-thermometer':
                return light('face-thermometer');
            case 'family':
                return light('family');
            case 'bed-pulse':
                return light('bed-pulse');
            case 'hospitals':
                return light('hospitals');
            case 'gavel':
                return light('gavel');
            case 'clipboard-medical':
                return light('clipboard-medical');
            default:
                return light('image-slash');
        }
    };

    const getPlanCostStyle = (type: string) => {
        switch (type) {
            case 'owed':
                return 'default';
            case 'credit':
                return 'green';
            default:
                return 'disabled';
        }
    };
    
    const handleExpandStandalone = (idx: number) => {
        const temp = [...expanded];
        temp.forEach((x) => {
            if (x.id === idx) {
                if (x.activeKey === '0') {
                    x.activeKey = '1';
                    setSwitched((prev) => (prev = false));

                    return;
                }

                x.activeKey = '0';
            }
        });

        setExpanded((prev) => (prev = temp));
    };

    const handleFilterOption = (e: string | number) => {
        setFilteringData({ filterOption: e });
    };

    const handleFilterInfo = (e: any) => {
        const localFormatStr = e.toLocaleString().split(', ')[0];

        setFilteringData({
            ...filteringData,
            filterInfo: localFormatStr.match(/^\d{2}\/\d{2}\/\d{4}$/)
                ? formatDate(e)
                : e,
        });
    };

    const handleFilter = () => {
        setFilterData(
            (prev: any) =>
            (prev = {
                filterOption: filteringData.filterOption,
                filterInfo: filteringData.filterInfo,
            })
        );
        setFilteringData((prev: any) => (prev = filteringData));
    };
    
    const getAlertButton = (alertInfo: any[], handleAlertClick: any) => {
        const alertBody = (
          <Col>
            <Row className="pb-7 m-0 fw-normal">
              {alertInfo && alertInfo[0].title}
            </Row>
      
            <Row className="pb-7 m-0 fw-light lh-xs">
              {alertInfo && alertInfo[0].description}
            </Row>
      
            <Col className="m-0 mt-3 d-flex justify-content-end">
              <Button
                onClick={() => handleAlertClick(alertInfo[0])}
                size="sm"
                variant="primary"
              >
                Complete
              </Button>
            </Col>
          </Col>
        );
      
        return (
          <Popover placement="top-end" popoverBody={alertBody}>
            <IconButton
              variant="icon-alert"
              icon={light('circle-exclamation')}
              size={'sm'}
            />
          </Popover>
        );
      };

    return (
        <>
        <Row className="mt-10">
            <Accordion
                onHandleExpand={() => handleExpandStandalone(0)}
                activeKey={expanded[0].activeKey}
                title={'Health Benefits'}
            >
                {activeHealthBenefits.map((benefit: any, index: number) => (
                    <AccordionBodyItem
                        key={index}
                        infoIcon={getCardIcon(
                            benefit['generic'] && benefit['generic']['icon']
                        )}
                        title={benefit['generic']['title']}
                        subtitle={
                            benefit['plan'] ? benefit['plan']['title'] : 'No Coverage'
                        }
                        price={
                            benefit['plan']
                                ? formatPrice(Math.abs(benefit['plan']['cost']))
                                : '$0.00'
                        }
                        originalPrice={
                            benefit['plan']
                                ? formatPrice(Math.abs(benefit['plan']['originalCost']))
                                : '$0.00'
                        }
                        isOriginalPriceShown={shouldShowCurrentValue}
                        priceStyleType={getPlanCostStyle(
                            benefit['plan']['cost'] === 0
                                ? ''
                                : benefit['plan'] && benefit['plan']['costType']
                        )}
                        isHint={benefit['generic']['hint']}
                        avatarGroup={
                            benefit['generic']['familyMembers'] && (
                                <AvatarGroup
                                    avatars={benefit.profiles}
                                    groupSize={AvatarGroupSize.MINIMIZED}
                                    groupStyle={AvatarGroupStyle.STACKED}
                                    hasTooltip
                                />
                            )
                        }
                    />
                ))}
            </Accordion>
        </Row>
        <Row className="mt-10">
          <Accordion
            onHandleExpand={() => handleExpandStandalone(2)}
            activeKey={expanded[2].activeKey}
            title={'Spending Accounts'}
          >
            {activeSpendingAccounts.map((benefit: any, index: number) => (
              <AccordionBodyItem
                key={index}
                infoIcon={getCardIcon(
                  benefit['generic'] && benefit['generic']['icon']
                )}
                infoIconVariant={'icon-default'}
                title={
                  !benefit['generic']
                    ? separateStringAndMakeFirstLetterUppercase(benefit['type'])
                    : benefit['generic']['title']
                }
                subtitle={
                  benefit['plan'] ? benefit['plan']['title'] : 'No Coverage'
                }
                price={
                  benefit['plan']
                    ? formatPrice(benefit['plan']['cost'])
                    : '$0.00'
                }
                originalPrice={
                  benefit['plan']
                    ? formatPrice(benefit['plan']['originalCost'])
                    : '$0.00'
                }
                isOriginalPriceShown={shouldShowCurrentValue}
                priceStyleType={getPlanCostStyle(benefit['plan']['costType'])}
              />
            ))}
          </Accordion>
        </Row>
        <Row className="mt-10">
          <Accordion
            onHandleExpand={() => handleExpandStandalone(3)}
            activeKey={expanded[3].activeKey}
            title={'Life & Disability Insurance'}
            infoIcon={light('circle-exclamation')}
          >
            {activeLifeAndDisabilityInsurances.map(
              (benefit: any, index: number) => (
                <AccordionBodyItem
                  key={index}
                  infoIcon={getCardIcon(
                    benefit['generic'] && benefit['generic']['icon']
                  )}
                  title={
                    !benefit['generic']
                      ? separateStringAndMakeFirstLetterUppercase(
                          benefit['type']
                        )
                      : benefit['generic']['title']
                  }
                  infoIconVariant={'icon-default'}
                  subtitle={
                    !benefit['plan']['id'].includes('noCoverage')
                      ? `${benefit['plan']['title']}${
                          benefit['plan']['coverage']
                            ? `, ${formatPrice(
                                benefit['plan']['coverage'],
                                'en-US',
                                {
                                  currency: 'USD',
                                  style: 'currency',
                                  minimumFractionDigits: 0,
                                }
                              )}`
                            : ''
                        }`
                      : 'No Coverage'
                  }
                  price={
                    benefit['plan']
                      ? formatPrice(benefit['plan']['cost'])
                      : '$0.00'
                  }
                  originalPrice={
                    benefit['plan']
                      ? formatPrice(benefit['plan']['originalCost'])
                      : '$0.00'
                  }
                  infoButton={
                    benefit['alerts'] &&
                    getAlertButton(benefit['alerts'], handleAlertClick)
                  }
                  isOriginalPriceShown={shouldShowCurrentValue}
                  priceStyleType={getPlanCostStyle(
                    benefit['plan'] && benefit['plan']['costType']
                  )}
                />
              )
            )}
          </Accordion>
        </Row>
        <Row className="mt-10">
          <Accordion
            onHandleExpand={() => handleExpandStandalone(1)}
            activeKey={expanded[1].activeKey}
            title={'Lifestyle Benefits'}
          >
            {activeLifestyleBenefits.map((benefit: any, index: number) => (
              <AccordionBodyItem
                key={index}
                infoIcon={getCardIcon(
                  benefit['generic'] && benefit['generic']['icon']
                )}
                title={
                  !benefit['generic']
                    ? separateStringAndMakeFirstLetterUppercase(benefit['type'])
                    : benefit['generic']['title']
                }
                infoIconVariant={'icon-default'}
                subtitle={
                  benefit['plan'] ? benefit['plan']['title'] : 'No Coverage'
                }
                price={
                  benefit['plan']
                    ? formatPrice(benefit['plan']['cost'])
                    : '$0.00'
                }
                originalPrice={
                  benefit['plan']
                    ? formatPrice(benefit['plan']['originalCost'])
                    : '$0.00'
                }
                isOriginalPriceShown={shouldShowCurrentValue}
                priceStyleType={getPlanCostStyle(
                  benefit['plan'] && benefit['plan']['costType']
                )}
              />
            ))}
          </Accordion>
        </Row>
        </>
    )
}

export default ElectionByDate